"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterRegistersByDate = void 0;
var date_fns_1 = require("date-fns");
var filterRegistersByDate = function (registers, date) {
    return registers.filter(function (_a) {
        var startDate = _a.startDate, endDate = _a.endDate;
        return !(0, date_fns_1.isBefore)(date, startDate) && endDate ? !(0, date_fns_1.isAfter)(date, endDate) : true;
    });
};
exports.filterRegistersByDate = filterRegistersByDate;
